import { SimpleTableBase } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { UsuarioContext } from '../../UsuarioContext';
import { usuarioModais } from '../modal/usuarioModais';
import UsuarioFab from '../UsuarioFab';

const VendedorTable = ({ fetchUsuarios, fetchUsuario, onDelete, onCreate }) => {
  const [vendedores] = useContext(UsuarioContext).usuarios;
  const [selecao, setSelecao] = useContext(UsuarioContext).selecao;
  const [loading] = useContext(UsuarioContext).loading;
  const [, setModal] = useContext(GlobalContext).modal;
  const [totalElements] = useContext(UsuarioContext).totalElements;
  const [tipoSelecao, setTipoSelecao] = useContext(UsuarioContext).tipoSelecao;

  const handleOpenModalVisualizar = async (usuario) => {
    await fetchUsuario(usuario.id);
    setModal(usuarioModais.visualizacaoUsuario);
  };

  const handleOpenModalEditar = async (usuario) => {
    await fetchUsuario(usuario.id);
    setModal(usuarioModais.cadastroUsuario);
  };

  const usuarioColumnDefs = [
    {
      title: 'Nome',
      name: 'nome',
      sortingEnabled: true,
      getCellValue: (usuario) => {
        return usuario.nome;
      },
    },
    {
      title: 'E-mail',
      name: 'email',
      sortingEnabled: true,
      getCellValue: (usuario) => {
        return usuario.email;
      },
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      width: 75,
      getCellValue: (usuario) => (
        <TableActionContainer>
          {permissaoUtils.usuario().editar && <TableActionButtonEdit onClick={() => handleOpenModalEditar(usuario)} />}
          {permissaoUtils.usuario().excluir && (
            <TableActionButtonDelete onClick={() => onDelete({ ids: [usuario], q: '', tipoSelecao: 'NENHUM' })} />
          )}
        </TableActionContainer>
      ),
    },
  ];

  return (
    <>
      <SimpleTableBase
        getRowId={(row) => row}
        columns={usuarioColumnDefs}
        rows={vendedores}
        fetchData={fetchUsuarios}
        loading={loading}
        onRowClick={handleOpenModalVisualizar}
        defaultSorting={[{ columnName: 'nome', direction: 'asc' }]}
        totalCount={totalElements}
        onCurrentPageChange={(params) => {
          console.log(params);
        }}
        onPageSizeChange={(params) => {
          console.log(params);
        }}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(tipo) => {
          setTipoSelecao(tipo);
        }}
        fetchOnCreate
        pageType="async"
        selection={selecao}
        onSelectionChange={setSelecao}
        onSortingChange={(params) => console.log(params)}
        onLoadingChange={(params) => console.log('loading change', params)}
        searchBy=""
      />
      {(permissaoUtils.usuario().cadastrar || permissaoUtils.usuario().excluir) && (
        <UsuarioFab selected={selecao.length} onDelete={onDelete} fetchUsuario={fetchUsuario} onCreate={onCreate} />
      )}
    </>
  );
};

export default VendedorTable;
